export default __webpack_public_path__ + "static/media/service-thumb-829301f40df535f46b7315391422a136.f7983143.jpg";